import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  NgModule,
  OnChanges,
  SimpleChanges,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { INullifyModalOptionsStyles } from '@shared/interfaces';
import { NullifyModalService } from '@core/services/system/nullify-modal.service';
import { TimePickerComponent } from '../time-picker/time-picker.component';
import { CompanyLocalizedPipeModule } from '@shared/pipes';
import { Subscription } from 'rxjs';

@Component({
  selector: 'pos-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeComponent implements OnChanges {
  @Input() value: string;
  @Output() posSetValue = new EventEmitter<string>();
  public readonly valueState = signal<string>(null);
  private popupSubscription: Subscription;

  constructor(
    private nullifyModalService: NullifyModalService,
    private destroyRef: DestroyRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const valueChange = changes.value;
    if (valueChange) {
      this.valueState.set(valueChange.currentValue || null);
    }
  }

  openPopup(event: Event) {
    const target = event.target as HTMLElement;
    if (this.nullifyModalService.isNullifyModalExist()) {
      return;
    }
    const targetRect = target.getBoundingClientRect();
    const height = 175;
    const padding = 10;
    const top = targetRect.top - height - padding;
    const styles: INullifyModalOptionsStyles = {
      top: `${top}px !important`,
      right: '0',
      left: 'initial !important',
      maxWidth: '100%',
      margin: '0 20px !important',
      padding: '25px !important',
      width: '182px !important',
      height: `${height}px !important`,
      zIndex: 30001,
    };
    const posSetValue = new EventEmitter<string>();
    this.popupSubscription?.unsubscribe();
    this.popupSubscription = posSetValue.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.value = value;
      this.valueState.set(value);
      this.posSetValue.emit(value);
    });
    const value = this.valueState();
    this.nullifyModalService.initModal({
      component: TimePickerComponent,
      options: { styles, className: 'pos-content-picker', arrAbove: false },
      inputs: [{ value, posSetValue }],
    });
  }
}
@NgModule({
  imports: [CompanyLocalizedPipeModule],
  declarations: [TimeComponent],
  exports: [TimeComponent],
})
export class TimeComponentModule {}
